import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { buttonIcon, titleIcon } from "../../../assets/images";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const BestsellerProducts = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const [list, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );

      // Tüm veriyi al ve sadece ilk 8 tanesini seç
      const filteredProducts = response.data.data.filter(
        (product) => product.isBestseller != 0
      );
      const limitedData = filteredProducts?.slice(0, 5);

      setItems(limitedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  if (isLoading) {
    return <p className="text-center text-[white]">Loading...</p>;
  }

  return (
    <div className="pt-10 md:pt-20">
      <div className="max-w-containerSm md:max-w-container mx-auto ">
        <div className="flex md:justify-between justify-center ">
          <div className="flex items-center">
            <img className="w-[50px] h-auto mr-2" src={titleIcon}></img>
            <p className="text-[24px] md:text-[28px] font-semibold text-center md:text-left text-[#181D27]">
              {t("Ən Çox Satılanlar")}
            </p>
          </div>
          <a className="hidden md:block" href={`/${currentLanguage}/products`}>
            <div className="flex justify-between items-center text-[#181D27] w-[124px] h-[44px]">
              <p>{t("Hamısına bax")}</p>
            </div>
          </a>
        </div>
        <div className="hidden md:grid grid-cols-1 md:grid-cols-4 gap-4 mt-10">
          {list.map((product) => {
            return (
              <ProductCard
                id={product.id}
                name={product.name}
                nameEn={product.nameEn}
                description={product.description}
                descriptionEn={product.descriptionEn}
                information={product.information}
                informationEn={product.informationEn}
                isNew={product.isNew}
                isBestseller={product.isBestseller}
                discount={product.discount}
                discountSituation={product.discountSituation}
                image1={product.image1}
                image2={product.image2}
                image3={product.image3}
                image4={product.image4}
                image5={product.image5}
              />
            );
          })}
        </div>
        <div className="block md:hidden mt-[24px] ">
          <Swiper
            slidesPerView={1}
            spaceBetween={20}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            onSlideChange={(swiper) => {
              setShowText(false);
              setShowButton(false);
              setActiveIndex(swiper.activeIndex);
            }}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper"
          >
            {list.map((product, index) => {
              return (
                <SwiperSlide key={index}>
                  <ProductCard
                    id={product.id}
                    name={product.name}
                    nameEn={product.nameEn}
                    description={product.description}
                    descriptionEn={product.descriptionEn}
                    information={product.information}
                    informationEn={product.informationEn}
                    isNew={product.isNew}
                    isBestseller={product.isBestseller}
                    discount={product.discount}
                    discountSituation={product.discountSituation}
                    image1={product.image1}
                    image2={product.image2}
                    image3={product.image3}
                    image4={product.image4}
                    image5={product.image5}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        <a className="block md:hidden" href={`/${currentLanguage}/products`}>
          <div className="flex justify-between items-center text-firstColor mt-[24px] h-[44px] w-[140px] mx-auto">
            <p>{t("Hamısına bax")}</p>
            <img className="w-2" src={buttonIcon}></img>
          </div>
        </a>
      </div>
    </div>
  );
};

export default BestsellerProducts;
